module.exports = __webpack_public_path__ + "static/396FC6_8_0-6abbe5e2394ae7dc60479775fd90acb2.woff";